module.exports = __webpack_public_path__ + "img/icon_dollar.bf247aac.svg";